/**
 * Chatwoot custom attributes from patient doc
 *
 * Maps `signedUpPatient` Firestore fields to Chatwoot contact attributes for support context.
 */

import type { ChatwootUserCustomAttributes, SignedUpPatient } from '@physiofit-digital/physiofit_types';

/**
 * Builds Chatwoot custom attributes from the signed-up patient snapshot.
 *
 * @param {Object} patient Current `signedUpPatients` document data.
 * @return {Object} Attributes with undefined values stripped.
 */
export function buildChatwootAttributesFromSignedUpPatient(patient: SignedUpPatient): ChatwootUserCustomAttributes {
  const practiceUserId = patient.practicePatients?.[patient.practiceId];
  const attrs: ChatwootUserCustomAttributes = {
    practice_user_id: practiceUserId,
  };

  if (patient.appUserId) {
    attrs.app_user_id = patient.appUserId;
  }

  // Strip undefined values so Chatwoot only receives registered attributes
  return Object.fromEntries(Object.entries(attrs).filter(([, v]) => v !== undefined)) as ChatwootUserCustomAttributes;
}
